import { render, staticRenderFns } from "./commonDialog.vue?vue&type=template&id=54120b89&"
import script from "./commonDialog.vue?vue&type=script&lang=js&"
export * from "./commonDialog.vue?vue&type=script&lang=js&"
import style0 from "./commonDialog.vue?vue&type=style&index=0&id=54120b89&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports